<template>
  <b-progress :type="progressColor(number)" :value="number" show-value>
  </b-progress>
</template>

<script>
export default {
  props: {
    number: { type: Number, required: true },
  },
  methods: {
    progressColor(value) {
      if (value < 31) {
        return 'is-danger';
      }

      if (value >= 31 && value < 85) {
        return 'is-warning';
      }

      return value > 84 ? 'is-success' : null;
    },
  },
};
</script>
